module.exports = __webpack_public_path__ + "static/01-9d47ab31a543115b0e7f03b08cb5b9c0.jpg";